import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Link,
  Select,
  Text as ChakraText,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { originCategory } from './utils'

interface Props {
  isDisabled?: boolean
}

const SelectOriginType = ({
  field,
}: Pick<FieldProps<string>, 'field'>): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Select {...field}>
      <optgroup label={t('s3_and_related_types', 'S3 and related types')}>
        {originCategory.s3Types.map(originObj => (
          <option key={originObj.text} value={originObj.typeId}>
            {originObj.text}
          </option>
        ))}
      </optgroup>
      <optgroup label={t('google', 'Google')}>
        {originCategory.google.map(originObj => (
          <option key={originObj.text} value={originObj.typeId}>
            {originObj.text}
          </option>
        ))}
      </optgroup>
      <optgroup label={t('azure', 'Azure')}>
        {originCategory.azure.map(originObj => (
          <option key={originObj.text} value={originObj.typeId}>
            {originObj.text}
          </option>
        ))}
      </optgroup>
      <optgroup label={t('web', 'Web')}>
        {originCategory.web.map(originObj => (
          <option key={originObj.text} value={originObj.typeId}>
            {originObj.text}
          </option>
        ))}
      </optgroup>
      <optgroup label={t('pim', 'PIM')}>
        {originCategory.pim.map(originObj => (
          <option key={originObj.text} value={originObj.typeId}>
            {originObj.text}
          </option>
        ))}
      </optgroup>
    </Select>
  )
}

export const OriginTypeSelectField = ({ isDisabled }: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Field name="typeId">
      {({ field, form }: FieldProps<string>) => (
        <FormControl
          isInvalid={Boolean(form.errors.typeId && form.touched.typeId)}
          isRequired
          isDisabled={isDisabled}
        >
          <FormLabel htmlFor="typeId">
            {t('origin_type', 'Origin Type')}
          </FormLabel>
          <ChakraText paddingBottom="0.8em">
            {t(
              'type_of_origin_integrate_with_imagekit',
              'Type of the origin you want to integrate with ImageKit.',
            )}{' '}
            <Link
              fontSize="1em"
              href="https://docs.imagekit.io/integration/configure-origin"
              isExternal
            >
              {t('learn_more', 'Learn more.')}
            </Link>
          </ChakraText>
          <SelectOriginType field={field} />
          <FormErrorMessage marginBottom="-2.0408em">
            {form.errors.typeId}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}
